// extracted by mini-css-extract-plugin
module.exports = {"hnui-hovercard":"HoverCard_hnui-hovercard__dpHEl","dark":"dark","scaleIn":"HoverCard_scaleIn__z8lcj"};